import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';

export const provideDialogEnvironment = (): EnvironmentProviders => makeEnvironmentProviders([DialogService]);
